import { Button } from '@mui/material';
import { useContext } from 'react';

import {
  DATA_DISPLAY_KEYS,
  PortfolioManagementContext,
} from '../../../../../providers/portfolio-management';
import { usePortfolioCalculateAggregatedAccounts } from '../../../hooks/use-portfolio-calculate-aggregated-accounts';
import { usePortfolioCalculatePerAccount } from '../../../hooks/use-portfolio-calculate-per-account';

import './styles.scss';

type PortfolioButtonCalculateProps = {
  isPortfolioSidebarOpen: boolean;
};

export const PortfolioButtonCalculate = ({
  isPortfolioSidebarOpen,
}: PortfolioButtonCalculateProps) => {
  const {
    selectedDataDisplayOption,
    isPortfolioLoading,
    selectedAccountsAggregated,
    riskSettingsSelected,
  } = useContext(PortfolioManagementContext);

  const { handlePortfolioCalculate, isAccountCalculated } = usePortfolioCalculatePerAccount();
  const { handlePortfolioCalculateAggregatedAccounts, isAccountCalculatedAggregatedAccounts } =
    usePortfolioCalculateAggregatedAccounts();

  const isDataDisplayPerAccount = selectedDataDisplayOption === DATA_DISPLAY_KEYS.perAccount;

  const isButtonCalcualteDisabled =
    isPortfolioLoading ||
    !selectedDataDisplayOption ||
    !isAccountCalculated ||
    riskSettingsSelected.volShocks.length === 0 ||
    riskSettingsSelected.times.length === 0 ||
    riskSettingsSelected.riskMetrics.length === 0;

  const isButtonCalcualteAggregatedAccountsDisabled =
    isPortfolioLoading || !selectedDataDisplayOption || selectedAccountsAggregated.length === 0;

  const handleClick = isDataDisplayPerAccount
    ? handlePortfolioCalculate
    : handlePortfolioCalculateAggregatedAccounts;

  const buttonWidth = isPortfolioSidebarOpen ? '100%' : '150px';

  const isButtonDisabled = isDataDisplayPerAccount
    ? isButtonCalcualteDisabled
    : isButtonCalcualteAggregatedAccountsDisabled;

  const buttonLabel = isDataDisplayPerAccount
    ? isAccountCalculated
      ? 'Recalculate'
      : 'Calculate'
    : isAccountCalculatedAggregatedAccounts
      ? 'Recalculate'
      : 'Calculate';

  return (
    <div className="portfolio-accounts-buttons-calculate-area">
      <Button onClick={handleClick} style={{ width: buttonWidth }} disabled={isButtonDisabled}>
        {buttonLabel}
      </Button>
    </div>
  );
};
